import { render, staticRenderFns } from "./IconbarItem.vue?vue&type=template&id=2ed4206b&scoped=true&"
import script from "./IconbarItem.vue?vue&type=script&lang=ts&"
export * from "./IconbarItem.vue?vue&type=script&lang=ts&"
import style0 from "./IconbarItem.vue?vue&type=style&index=0&id=2ed4206b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed4206b",
  null
  
)

export default component.exports